module.exports = (() => ((name) => import(name)))();